module.exports = __webpack_public_path__ + "static/media/applied-machine-learning-img.4eb39b50.jpg";